import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ItemFinance from './itemFinance';
import {
  ButtonGroup,
  Button,
  Col,
  Tab,
  Row,
  Nav,
  ListGroup,
} from 'react-bootstrap';
import { translate } from 'react-i18next';

import * as _ from 'lodash';

class Finance extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      typeSummary: 2, // 2: hang quy, 1: hang nam
    };
  }

  _handleClickTypeSummary = (typeSummary) => {
    if (typeSummary !== this.state.typeSummary) {
      this.setState({ typeSummary });

      // TODO: call summary report
      this.props.loadFinance(typeSummary);
    }
  };

  componentDidUpdate(preProps) {
    const { symbol } = this.props;

    if (symbol && symbol !== preProps.symbol)
      this.props.loadFinance(this.state.typeSummary);
  }

  render() {
    const { cst, kqkd, cdkt, t } = this.props;

    const { typeSummary } = this.state;

    // console.log(cst);
    return (
      <div className="d-flex content-finance">
        <Col md="4" className="p-0">
          <div
            className="bb-1 fz-14 align-items-center"
            style={{ height: '26px' }}
          >
            Chi tiêu tài chính
          </div>
          <PerfectScrollbar style={{ height: 'calc(100vh - 335px)' }}>
            <ListGroup>
              <ListGroup.Item variant="info" className="fz-14">
                Định giá
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">EPS</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 53)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">PE</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 55)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">PB</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 57)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item variant="info" className="fz-14">
                Khả năng sinh lời
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">ROE</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 45)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">ROA</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 47)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">Tỷ suất LN gộp</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 41)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">Biên LN ròng</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 44)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item variant="info" className="fz-14">
                Sức mạnh tài chính
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">Tổng nợ/VCSH</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 12)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">Tổng nợ/Tổng TS</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 7)?.Value4}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex">
                <span className="fz-14 mr-auto">Thanh toán</span>
                <span className="fz-14">
                  {_.find(cst.Content, (o) => o.ReportNormID === 1)?.Value4}
                </span>
              </ListGroup.Item>
            </ListGroup>
          </PerfectScrollbar>
        </Col>
        <Col md="8">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Nav
                variant="pills"
                className="d-flex flex-row position-relative bb-1 w-100"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first" className="fz-14">
                  {t('txt-label-income-statement')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second" className="fz-14">
                  {t('txt-label-balance-sheet')}
                  </Nav.Link>
                </Nav.Item>
                <ButtonGroup
                  aria-label="Basic example"
                  style={{
                    position: 'absolute',
                    // top: '100%',
                    right: '0',
                    // transform: '-50% -50%',
                    // transform: 'translate(-50%, -50%)',
                  }}
                >
                  <Button
                    variant="secondary"
                    className={
                      'fz-12 text-uppercase ' +
                      (typeSummary === 2 ? 'active' : '')
                    }
                    style={{ padding: '2px 5px' }}
                    onClick={() => this._handleClickTypeSummary(2)}
                  >
                    {t('txt-label-quarterly')}
                  </Button>
                  <Button
                    variant="secondary"
                    className={
                      'fz-12 text-uppercase ' +
                      (typeSummary === 1 ? 'active' : '')
                    }
                    style={{ padding: '2px 5px' }}
                    onClick={() => this._handleClickTypeSummary(1)}
                  >
                    {t('txt-label-annual')}
                  </Button>
                </ButtonGroup>
              </Nav>
            </Row>
            <Row>
              <PerfectScrollbar style={{ height: 'calc(100vh - 335px)' }}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <ItemFinance
                      className="mt-2 ml-2"
                      resource={kqkd}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <ItemFinance
                      className="mt-2 ml-2"
                      resource={cdkt}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </PerfectScrollbar>
            </Row>
          </Tab.Container>
        </Col>
      </div>
    );
  }
}

export default translate('translations')(Finance);
